/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import WaveLoading from '../../../share/WaveLoading'
import { useDashboardWidgetData } from '../../../../hooks/useWidgetState'

// eslint-disable-next-line react/prop-types
const WidgetLoadingGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData(widgetId)

  if (!widgetData || widgetData.status === 'loading') return <WaveLoading />

  return children
}

export default WidgetLoadingGuard
